import React from "react";

export default function ReviewStars({ stars, cta, className = "" }) {
  function render() {
    return (
      <div className={`badge bg-white text-dark m-0 cursor-pointer ${className}`.trim()} onClick={cta}>
        {stars > 0 ? (
          <>
            <i className="fa-solid fa-star" style={{ color: "#f47621" }} /> <span style={{ fontWeight: 400 }}>{stars}</span>
          </>
        ) : (
          <>
            <i className="far fa-star" style={{ color: "#f47621" }} /> <span style={{ fontWeight: 400 }}>0</span>
          </>
        )}
      </div>
    );
  }

  return render();
}
